import React from 'react';
import logo1 from '../../assets/logo1.png';
import logo2 from '../../assets/logo2.png';
import logo3 from '../../assets/logo3.png';
import logo4 from '../../assets/logo4.png';
import './main.css';

const logos = [logo1, logo2, logo3, logo4];

const Main = () => {
  return (
    <section className="main">
      <div className="mainContent">
        {logos.map((logo, index) => (
          <div className="items" key={index}>
            <img src={logo} alt={`logo-${index}`} />
          </div>
        ))}
        {logos.map((logo, index) => (
          <div className="items" key={index + logos.length}>
            <img src={logo} alt={`logo-${index}`} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Main;
